export class  ValueGraph {
    controllerDesignations: string[] = [];
    properties: string[] = [];
    dateTimeFrom: string;
    dateTimeTo: string;
  }
